<style>
.mobile-only {
  display: block;
}

@media (min-width: 600px) {
  .mobile-only {
    display: none;
  }
}

.desktop-only {
  display: block;
}

@media (max-width: 600px) {
  .desktop-only {
    display: none;
  }
}
</style>
<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Activos Fijos</h5>
        <div class="controls-above-table">
          <div class="row flex-md-row-reverse">
            <div class="form-inline justify-content-sm-end">
              <select
                class="form-control form-control-sm rounded bright"
                v-model="filterActivo"
                @change="filterData()"
              >
                <option :value="null">Todos</option>
                <option value="E">Excelente</option>
                <option value="B">Buen Estado</option>
                <option value="M">Mal Estado</option>
                <option value="9">De Baja</option>
              </select>

              <input
                class="form-control form-control-sm rounded bright"
                placeholder="Buscar"
                v-model="searchtext"
                type="text"
              />
              <div class="input-group-append">
                <button class="btn btn-link btn-sm" @click="filterData()">
                  <i class="fa fa-search"></i>
                </button>
                <button
                  class="btn btn-link btn-sm"
                  type="button"
                  v-on:click="clearFilterData()"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>

            &nbsp; &nbsp;
            <TiendaSelectComponent
              class="col-sm-2"
              _class="form-control form-control-sm rounded bright"
              titulo="hide"
              style="display: block"
              :desblock="true"
              placeholder="FILTRO DE TIENDAS"
              :current="filter"
              @change="filterData()"
              @onChange="filterData()"
            />
            <GrupoActivoComponent
              titulo="hide"
              class="col-sm-2"
              style="display: block"
              :desblock="true"
              :current="filter"
              placeholder="FILTRO DE CATEGORÍA"
              _class="form-control form-control-sm rounded bright"
              :incluir_en_blanco="true"
              @change="filterData()"
              @onChange="filterData()"
            />
          </div>
          <hr />
          <div class="row">
            <div class="col-9">
              <h6>Listado de AF</h6>
            </div>
          </div>
          <div style="text-align: right">
            <router-link class="btn btn-md btn-info" :to="{ name: 'af-activos-nuevo' }">
              <i class="fa fa-plus"></i>
              Agregar Nuevo
            </router-link>
          </div>
        </div>

        <div class="table-responsive mobile-only">
          <!-------------------- Tabla de Resultados version movil -------------------->
          <table class="table table-hover">
            <thead>
              <tr>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="det in data.results" v-bind:key="det.id" @click="rowClick(det)">
                <td>
                  <div class="value">
                    <span style="font-size: 12px" class="sub-value font-weight-bold">
                      {{ det.nombre }}
                    </span>
                  </div>
                  <small class="font-weight-bold text-success">{{
                    det.identificador
                  }}</small>
                  <br />
                  <span class="sub-value">
                    <small>
                      {{ det.fecha_creacion | moment("DD/MM/YYYY hh:mm a") }}</small
                    >
                  </span>
                </td>
                <td>
                  <span class="sub-value font-weight-bold">
                    {{ det.grupo_obj.nombre }}
                  </span>
                  <div class="value">
                    <span class="font-weight-bold text-success"
                      >{{ det.tienda_obj.codigo }} - {{ det.tienda_obj.nombre }}</span
                    >
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-------------------- END tabla movil-------------------->

        <div class="table-responsive desktop-only">
          <!-------------------- Tabla de Resultados version desk -------------------->
          <table class="table table-hover">
            <thead>
              <tr>
                <th class="text-left">Código interno</th>
                <th class="text-left">Nombre</th>
                <th class="text-center">Tienda</th>
                <th class="text-center">Categoría</th>
                <th class="text-center">Fecha creación</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="current in data.results"
                v-bind:key="current.id"
                @click="rowClick(current)"
              >
                <td class="text-left">{{ current.identificador }}</td>
                <td class="text-left">{{ current.nombre }}</td>
                <td class="text-center">
                  {{ current.tienda_obj.codigo }} - {{ current.tienda_obj.nombre }}
                </td>
                <td class="text-center">
                  <span v-if="current && current.grupo_obj">{{
                    current.grupo_obj.nombre
                  }}</span>
                </td>
                <td class="text-center">
                  {{ current.fecha_creacion | moment("DD/MM/YYYY hh:mm a") }}
                </td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END desk table -------------------->
        </div>
        <PaginationComponent
          :currentPage="currentPage"
          :data="data"
          @pagechanged="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import DynamicService from "@/services/commons/DynamicService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import GrupoActivoComponent from "@/components/commons/GrupoActivoComponent";

export default {
  components: {
    PaginationComponent,
    TiendaSelectComponent,
    GrupoActivoComponent,
  },
  data() {
    return {
      current: {},
      mostrarRefresh: false,
      filter: { tienda: "", grupo: null },
      currentPage: 1,
      searchtext: "",
      filterActivo: null,
      data: [],
    };
  },
  mounted() {
    this.refreshData();
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        tienda: this.filter.tienda,
        grupo: this.filter.grupo,
        "filter[search]": this.searchtext,
        activo: this.filterActivo,
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        grupo: this.filter.grupo,
        tienda: this.filter.tienda,
        "filter[search]": this.searchtext,
        estado: this.filterActivo,
      });
    },
    clearFilterData() {
      this.searchtext = "";
      this.filterActivo = null;
      this.filter.tienda = "";
      this.filter.grupo = null;
      this.refreshData({
        page: 1,
      });
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
      DynamicService.fetch("af", "activo", params).then((res) => {
        self.data = res.data;
      });
    },
    rowClick(current) {
      let self = this;
      self.$router.push({
        name: "af-activos-editar",
        params: { id: current.id },
      });
    },
    showModalEdit() {},
  },
};
</script>
